import React from 'react'

import {Box, Theme} from '@mui/material'
import {PGTypography} from '@progynyglobal/pg-ui-library'
import {makeStyles} from 'tss-react/mui'

export interface NavigationItem {
  itemID: string
  label: string
}

export interface NavigationProps {
  items: NavigationItem[]
  activeItemID: string
  onItemClick?: (itemID: string) => void
  colors?: any // Product line colors
}

const useStyles = makeStyles<{colors: any}>()((theme: Theme, {colors}) => ({
  container: {
    display: 'flex',
    padding: '5px',
    alignItems: 'flex-start',
    gap: '6px',
  },
  item: {
    padding: '10px 20px',
    borderRadius: '100px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '&:hover': {
      opacity: 0.8,
    },
  },
  inactiveItem: {
    color: '#6B7280',
    background: 'transparent',
  },
  activeItem: {
    color: '#fff',
    background: colors?.primary || '#148199',
  },
}))

const Navigation: React.FC<NavigationProps> = ({
  items,
  activeItemID,
  onItemClick,
  colors,
}) => {
  const {classes} = useStyles({colors})

  const handleItemClick = (itemID: string) => {
    if (onItemClick) {
      onItemClick(itemID)
    }
  }

  return (
    <Box className={classes.container}>
      {items.map((item) => {
        const isActive = item.itemID === activeItemID
        const itemClass = isActive ? classes.activeItem : classes.inactiveItem

        return (
          <Box
            key={item.itemID}
            className={`${classes.item} ${itemClass}`}
            onClick={() => handleItemClick(item.itemID)}
            data-testid={`consultations-nav-${item.itemID}`}
          >
            <PGTypography
              variant='caption'
              sx={{
                fontWeight: itemClass === classes.activeItem ? 700 : 500,
              }}
            >
              {item.label}
            </PGTypography>
          </Box>
        )
      })}
    </Box>
  )
}

export default Navigation
